import { render, staticRenderFns } from "./CommercialContent.vue?vue&type=template&id=1cf830c8"
import script from "./CommercialContent.vue?vue&type=script&lang=js"
export * from "./CommercialContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports